import { passengerTypeAction } from "../../../Actions/Index";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { SearchStateType } from "../../../Orchestrator/Types/Index";
import { HomePageContext } from "../Context/HomePageContext";
import dayjs from 'dayjs';

export class HomePageInitStep extends StepFlow {
    get stepName() { return "HomeStartupInit_Step"; }


    async onEventSetup(): Promise<void> {

    }

    async onExecute(): Promise<void> {
        // Force to re-calculate time for fmlm search modal open
        updateRecoilState("isDepartureDateChangedAtom", true);

        // Fetch and cache passenger types for the session — fire-and-forget.
        // This call is token-gated (queued until TOKEN_READY) and only feeds the
        // passengers dropdown atom; awaiting it here would serialize the entire
        // public CMS fan-out (banner, routes, news, ...) behind auth + gateway.
        void passengerTypeAction.execute().then(() => {
            if (passengerTypeAction.result?.length) {
                updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
            }
        });

        // const searchState: SearchStateType = {
        //     from: "",
        //     fromName: "",
        //     to: "",
        //     toName: "",
        //     calc: "",
        //     passengers: { adults: 1 },
        //     outboundDate: dayjs(),
        //     inboundDate: null,
        //     fromShuttle: false,
        //     toShuttle: false
        // }
        // updateRecoilState("searchStateAtom", searchState);

        this.setCtx("HomePageContext", new HomePageContext(["HomeBannerWidgetStep", "MainBookingFlow", "BookItAgainFlow", "DestinationsFlow", "FavouriteDepartureFlow", "UsefulInformationStep", "RoutesStep", "TrustBuilderStep", "NewsWidgetStep", "EnhancedTripsStep", "FavouriteTripsStep", "PopularTripsStep", "DepartureFromStep"]));
        this.next();
    }
}
export const homePageInitStepDeclaration = new StepDefinition({
    stepName: "HomeStartupInit_Step",
    stepClass: HomePageInitStep
});